<template>
  <div class="register">
    <aside class="register__side">
      <div class="register__side-inner">
        <div class="register__brand" @click="$router.push('/')">
          <span class="register__brand-mark">S</span>
          <strong>Sauda</strong>
        </div>

        <div class="register__side-text">
          <h2>Создайте магазин за пару минут</h2>
          <p>После регистрации сразу открывается касса — можно продавать</p>
        </div>

        <ol class="register__steps">
          <li>
            <span>1</span>
            <div>
              <strong>Зарегистрируйтесь</strong>
              <small>Название магазина, e-mail и пароль</small>
            </div>
          </li>
          <li>
            <span>2</span>
            <div>
              <strong>Добавьте товары</strong>
              <small>Категории, цены и остатки на складе</small>
            </div>
          </li>
          <li>
            <span>3</span>
            <div>
              <strong>Продавайте</strong>
              <small>С телефона, планшета или компьютера</small>
            </div>
          </li>
        </ol>
      </div>
    </aside>

    <main class="register__main">
      <div class="register__mobile-brand" @click="$router.push('/')">
        <span class="register__brand-mark">S</span>
        <strong>Sauda</strong>
        <small>Создайте магазин за пару минут</small>
      </div>

      <form class="register__card" @submit.prevent="submit">
        <div class="register__card-head">
          <h1>Регистрация</h1>
          <p>Аккаунт администратора вашего магазина</p>
        </div>

        <label class="register__field">
          <span>Название магазина</span>
          <div class="register__input">
            <i class="mdi mdi-storefront-outline"></i>
            <input
              v-model.trim="form.company_name"
              type="text"
              placeholder="Например: Дүкен №1"
              required
            >
          </div>
        </label>

        <label class="register__field">
          <span>E-mail</span>
          <div class="register__input">
            <i class="mdi mdi-email-outline"></i>
            <input
              v-model.trim="form.email"
              type="email"
              placeholder="you@example.com"
              autocomplete="username"
              required
            >
          </div>
        </label>

        <label class="register__field">
          <span>Пароль</span>
          <div class="register__input">
            <i class="mdi mdi-lock-outline"></i>
            <input
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Минимум 8 символов"
              autocomplete="new-password"
              required
            >
            <button type="button" class="register__eye" @click="showPassword = !showPassword">
              <i :class="['mdi', showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline']"></i>
            </button>
          </div>
          <em v-if="form.password && form.password.length < 8" class="register__hint">
            Пароль слишком короткий — минимум 8 символов
          </em>
        </label>

        <button type="submit" class="register__submit" :disabled="loading">
          <i v-if="loading" class="mdi mdi-loading mdi-spin"></i>
          {{ loading ? 'Создаём аккаунт...' : 'Зарегистрироваться' }}
        </button>

        <SocialAuthButtons divider="или войти через" />

        <p class="register__login">
          Уже есть аккаунт?
          <a @click.prevent="$router.push('/kassa-login')">Войти</a>
        </p>

        <button type="button" class="register__back" @click="$router.push('/')">
          <i class="mdi mdi-arrow-left"></i>
          На главную
        </button>
      </form>
    </main>
  </div>
</template>

<script>
import http from '@/api/http'
import { persistAuthSession } from '@/api/auth'
import SocialAuthButtons from '@/components/SocialAuthButtons'
import { notify, notifyError } from '@/utils/notify'

export default {
  name: 'RegisterPage',
  components: { SocialAuthButtons },
  data() {
    return {
      loading: false,
      showPassword: false,
      form: {
        email: '',
        password: '',
        company_name: '',
      },
    }
  },
  methods: {
    async submit() {
      if (!this.form.company_name) {
        notify('Укажите название магазина', 'warning')
        return
      }
      if (!/.+@.+\..+/.test(this.form.email)) {
        notify('Неправильный e-mail', 'warning')
        return
      }
      if (!this.form.password || this.form.password.length < 8) {
        notify('Пароль минимум 8 символов', 'warning')
        return
      }

      this.loading = true
      try {
        const { data } = await http.post('registration', this.form)
        persistAuthSession({
          ...data,
          company_role: 'admin',
          can_manage_products: true,
          user_name: '',
        })
        notify('Регистрация успешна')
        this.$router.push('/cash')
      } catch (error) {
        notifyError(error, 'Ошибка регистрации')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
$ink: #152033;
$muted: #6b7a90;
$accent: #0b4f8a;
$line: #d9e2ec;

.register {
  display: flex;
  min-height: 100vh;
  background: #f6f9fc;
}

/* ---------- Левая панель ---------- */
.register__side {
  width: 44%;
  color: #fff;
  background:
    radial-gradient(circle at 20% 15%, rgba(90, 168, 220, 0.26), transparent 40%),
    linear-gradient(160deg, #143252 0%, #10243a 60%, #0d1c2e 100%);
}

.register__side-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px 48px;
}

.register__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  align-self: flex-start;

  strong {
    font-size: 19px;
    font-weight: 800;
  }
}

.register__brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(180deg, #fff, #eef5fb);
  color: $accent;
  font-weight: 800;
  font-size: 18px;
}

.register__side-text {
  margin-top: auto;

  h2 {
    margin: 0 0 10px;
    font-size: 30px;
    font-weight: 800;
    line-height: 1.25;
    letter-spacing: -0.02em;
    max-width: 380px;
  }

  p {
    margin: 0 0 28px;
    opacity: 0.8;
    font-size: 15px;
  }
}

.register__steps {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;

  li {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  span {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.14);
    font-weight: 800;
    font-size: 15px;
  }

  strong {
    display: block;
    font-size: 14.5px;
    font-weight: 750;
  }

  small {
    display: block;
    margin-top: 1px;
    font-size: 12.5px;
    opacity: 0.72;
  }
}

/* ---------- Форма ---------- */
.register__main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
}

/* Брендинг над формой — только на мобильных */
.register__mobile-brand {
  display: none;
}

.register__card {
  width: 100%;
  max-width: 440px;
  padding: 36px 34px 28px;
  background: #fff;
  border: 1px solid #e3ebf3;
  border-radius: 22px;
  box-shadow: 0 20px 60px rgba(18, 32, 51, 0.08);
}

.register__card-head {
  margin-bottom: 26px;

  h1 {
    margin: 0 0 6px;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: $ink;
  }

  p {
    margin: 0;
    color: $muted;
    font-size: 14px;
  }
}

.register__field {
  display: block;
  margin-bottom: 16px;

  > span {
    display: block;
    margin-bottom: 7px;
    font-size: 13px;
    font-weight: 700;
    color: $ink;
  }
}

.register__hint {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  font-style: normal;
  color: #b45309;
}

.register__input {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  border: 1.5px solid $line;
  border-radius: 13px;
  background: #fbfdff;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;

  &:focus-within {
    border-color: $accent;
    box-shadow: 0 0 0 4px rgba(11, 79, 138, 0.1);
  }

  > .mdi {
    color: $muted;
    font-size: 19px;
  }

  input {
    flex: 1;
    min-width: 0;
    padding: 14px 0;
    border: 0;
    background: transparent;
    font-size: 15px;
    color: $ink;

    &::placeholder {
      color: #9fb0c2;
    }
  }
}

.register__eye {
  border: 0;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  color: $muted;

  .mdi {
    font-size: 19px;
  }

  &:hover {
    color: $accent;
  }
}

.register__submit {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 6px;
  padding: 15px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, #12324f, $accent);
  color: #fff;
  font-size: 16px;
  font-weight: 780;
  cursor: pointer;
  transition: opacity 0.18s ease, transform 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: wait;
  }

  .mdi {
    font-size: 18px;
  }
}

.register__login {
  margin: 18px 0 0;
  text-align: center;
  font-size: 14px;
  color: $muted;

  a {
    color: $accent;
    font-weight: 700;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.register__back {
  display: flex;
  width: fit-content;
  align-items: center;
  gap: 6px;
  margin: 18px auto 0;
  padding: 8px 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: $muted;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;

  .mdi {
    font-size: 16px;
  }

  &:hover {
    color: $accent;
    background: #eef4fa;
  }
}

/* ---------- Адаптив ---------- */
@media (max-width: 900px) {
  .register__side {
    display: none;
  }

  /* Тёмный фирменный фон на весь экран, карточка «плавает» на нём */
  .register {
    background:
      radial-gradient(circle at 80% -10%, rgba(90, 168, 220, 0.28), transparent 45%),
      radial-gradient(circle at 10% 100%, rgba(245, 158, 11, 0.1), transparent 40%),
      linear-gradient(165deg, #143252 0%, #10243a 55%, #0d1c2e 100%);
  }

  .register__main {
    justify-content: flex-start;
    padding: 40px 18px 28px;
  }

  .register__mobile-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin-bottom: 26px;
    color: #fff;
    cursor: pointer;
    text-align: center;

    .register__brand-mark {
      width: 52px;
      height: 52px;
      border-radius: 16px;
      font-size: 24px;
      margin-bottom: 8px;
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.3);
    }

    strong {
      font-size: 22px;
      font-weight: 800;
      letter-spacing: -0.01em;
    }

    small {
      font-size: 13.5px;
      opacity: 0.75;
    }
  }

  .register__card {
    border: 0;
    border-radius: 24px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
  }
}

@media (max-width: 480px) {
  .register__main {
    padding: 32px 14px 24px;
  }

  .register__card {
    padding: 26px 20px 20px;
  }

  .register__card-head h1 {
    font-size: 23px;
  }

  /* 16px — чтобы iOS не зумил поле при фокусе */
  .register__input input {
    font-size: 16px;
    padding: 15px 0;
  }

  .register__submit {
    padding: 16px;
  }
}
</style>
